/**
 * 地图还在读、或读不出来时的外壳（第 0b 步）：不能是死胡同——左上进小窝、通讯器、回忆和右上“我的”一直在（10-03 起不再挂底栏）。
 * - 跨多个家又没指明宠物（后端 409，details.reason = pet_required；W1 加了可选 petId 以后唯一还会报的这种错）：
 *   说人话，给去选的入口（“我的”，那里有切换宠物的栏）；不给“重试”（重试还是一样）。后端原话和错误码不上页面
 *   （用户 10-09 定稿 X-09／U-26：玩家端不显示技术代码，也不做“展开看详情”的折叠区，要查只在运营后台查）。
 * - 其他错误：照旧用统一错误态，能重试。
 * 这里不自己拼 pet_id 绕过去：跨家时前端该不该带、带哪只，由当前宠物决定（见 MapHomePage 的 LiveMapHome）。
 */
import type { ReactNode } from "react";
import { Link } from "react-router";
import { toApiError } from "@/shared/api/errors";
import { ErrorState, Icon, Page } from "@/shared/ui";
import { HOME_TAB } from "@/app/primaryTab";
import { SceneControls } from "@/shared/ui/SceneControls";

export const PET_REQUIRED_TEXT = "你在不止一个家里照顾伙伴，先选一只再看地图。";

export function isPetRequired(error: unknown): boolean {
  const err = toApiError(error);
  return err.status === 409 && err.details?.reason === "pet_required";
}

export function MapStatusShell({ children }: { children: ReactNode }) {
  return (
    <>
      <Page className="ps-wmap-shell">
        <SceneControls scene="map" sceneHref={HOME_TAB.to} petDisabled personalLabel="我的" />
        {children}
      </Page>
    </>
  );
}

export function MapLoadError({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  if (!isPetRequired(error)) return <ErrorState error={error} onRetry={onRetry} />;
  return (
    <div className="ps-state ps-state--error" role="alert">
      <div className="ps-state__icon">
        <Icon name="user" />
      </div>
      <div className="ps-state__title">{PET_REQUIRED_TEXT}</div>
      <Link className="ps-btn ps-btn--primary" to="/me">
        去“我的”选一只
      </Link>
    </div>
  );
}
